import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { DARK_KUBBE, BACKGROUND_KUBBE } from "../../constants/Colors";
import Footer from "../../assets/img/Footer.png";
import NavBarRoot from "../../components/molecules/NavBarRoot/NavBarRoot";
import Accordion from "./components/Accordion";

export const faqData = [
  {
    title: "¿Qué es Buena Ruta?",
    content:
      "Buena Ruta es una plataforma digital que conecta directamente a dadores de carga (DC) con transportistas (TC). Permite operar sin intermediarios, reduciendo tiempos muertos y costos operativos para hacer la logística más ágil y eficiente.",
  },
  {
    title: "¿Cómo me registro en la plataforma?",
    content:
      "Podés registrarte desde la aplicación o desde la web, completando un formulario con tus datos. Es un proceso rápido que te permite empezar a operar de inmediato. La app está disponible para descargas en Android.",
  },
  {
    title: "¿Cómo se publica una carga o se busca un viaje?",
    content:
      "Una vez dentro de tu cuenta, podés publicar cargas o consultar viajes disponibles de acuerdo a tu ubicación, al tipo de carga y a tus necesidades logísticas. El sistema es intuitivo y muy fácil de usar.",
  },
  {
    title: "¿Puedo confiar en los transportistas o dadores que encuentro?",
    content:
      "Sí. Todos los usuarios están verificados. Buena Ruta elimina intermediarios y prioriza la transparencia, generando relaciones seguras y directas entre las partes.",
  },
  {
    title: "¿Qué beneficios obtengo como dador de carga?",
    content:
      "Accedés a una red de transportistas verificados, reducís tiempos de espera, eliminás costos innecesarios y ganás eficiencia en tus operaciones.",
  },
  {
    title: "¿Qué beneficios tengo como transportista?",
    content:
      "Podés encontrar cargas en tiempo real, evitar viajes vacíos y mejorar la rentabilidad por cada kilómetro recorrido.",
  },
  {
    title: "¿Dónde opera Buena Ruta?",
    content:
      "Actualmente la plataforma funciona en toda la región NOA, con planes de expansión a nivel nacional e internacional.",
  },
  {
    title: "¿Qué tipo de cargas puedo gestionar en la plataforma?",
    content: "Se pueden gestionar cargas agrícolas, industriales y generales.",
  },
  {
    title: "¿La plataforma funciona en tiempo real?",
    content:
      "Sí. La conexión entre oferta y demanda es inmediata, lo que facilita decisiones logísticas más rápidas y efectivas.",
  },
  {
    title: "¿Puedo usar Buena Ruta desde el celular?",
    content:
      "Sí. La plataforma está optimizada para dispositivos móviles y también cuenta con versión web.",
  },
  {
    title: "¿Cómo se garantiza la seguridad en los acuerdos?",
    content:
      "Mediante perfiles verificados, relaciones directas entre usuarios y un sistema basado en la confianza y la eficiencia.",
  },
  {
    title: "¿Qué pasa si tengo un inconveniente con una carga o transporte?",
    content:
      "Podés comunicarte con nuestro equipo de soporte desde la app, a través del sistema de mensajería, o desde la web oficial en la sección “Mensajería Soporte”. Nuestro equipo está preparado para ayudarte a resolver cualquier problema de forma rápida y eficiente.",
  },
  {
    title: "¿Puedo cancelar una carga o viaje ya acordado?",
    content:
      "Sí, aunque dependerá del estado en que se encuentre el viaje al momento de solicitar la cancelación. En algunos casos se podrá hacer de inmediato, mientras que en otros será necesario que el equipo de soporte lo revise. Lo recomendable es notificarlo lo antes posible para evitar sanciones o perjuicios a los demás usuarios.",
  },
  {
    title: "¿Qué tipo de vehículos pueden registrarse?",
    content:
      "Se pueden registrar camiones y vehículos de transporte de todo tipo, siempre que cumplan con los requisitos legales y técnicos para operar.",
  },
  {
    title: "¿Es necesario tener CUIT para registrarme?",
    content:
      "Sí, es obligatorio contar con un CUIT activo. Este requisito aplica tanto a transportistas como a empresas, y garantiza la trazabilidad fiscal y legal de todos los servicios.",
  },
  {
    title: "¿La plataforma emite comprobantes o contratos?",
    content:
      "Sí. Cuando un viaje se completa y la documentación está cargada, se emite un comprobante digital válido para el cobro y que también sirve para fines contables y de facturación.",
  },
  {
    title: "¿Puedo operar con cargas o transportes internacionales?",
    content:
      "Por el momento, la plataforma está enfocada en operaciones dentro del territorio nacional. Si tenés habilitación para transporte internacional, podés comunicarte con nuestro equipo para evaluar la integración de tus servicios.",
  },
  {
    title: "¿Qué pasa si no encuentro carga o transporte disponible?",
    content:
      "La plataforma cuenta con un sistema de notificaciones que te avisa cuando aparecen nuevas cargas o viajes que se ajustan a tu perfil. También podés revisar periódicamente el listado actualizado de oportunidades desde la app o la web.",
  },
  {
    title: "¿Tiene algún costo usar Buena Ruta?",
    content:
      "Registrarse y usar la plataforma no tiene costo. Solo se cobra una comisión por cada viaje efectivamente realizado.",
  },
];

const FooterWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  background-color: ${DARK_KUBBE};
  padding: 20px 0px;
  display: flex;
  img {
    height: clamp(20px, 5vw, 50px);
    object-fit: cover;
    margin: auto;
  }
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0px;
  }
`;

const DivBackground = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${BACKGROUND_KUBBE};
  background-repeat: no-repeat !important;
  background-size: cover !important;
  padding: 0 30px;

  @media (max-width: 991px) {
    padding: 0 10px;
  }
`;
const Faq = () => {
  const history = useHistory();

  return (
    <>
      <DivBackground>
        <header>
          <NavBarRoot />
        </header>
        <main
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
          }}
        >
          <h2 className="h2 text-center font-weight-bold">
            Preguntas frecuentes
          </h2>
          <Accordion data={faqData} />
        </main>
        <footer>
          <FooterWrapper>
            <img src={Footer} alt="footer" />
          </FooterWrapper>
        </footer>
      </DivBackground>
    </>
  );
};

export default Faq;
